import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import PolicyBlockPage from '../../components/Policy/components/PolicyBlockPage';
import { usePolicyEnabled } from '../../components/Policy/hooks/usePolicyEnabled';
import PoliciesRoutes from '../../components/Policy/PoliciesRoutes';

export const PolicyRouting = (props: LogicalRouteImportProps) => {
    const displayBlockPage = !usePolicyEnabled();
    const disabled = !useHasPermissions({ permission: Pages.POLICIES, role: Roles.VIEWER });

    return (
        <LogicalRoute
            {...props}
            component={PoliciesRoutes}
            blockPageComponent={PolicyBlockPage}
            displayBlockPage={displayBlockPage}
            disabled={disabled}
        />
    );
};
